var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-notice-list"
  }, [_c('v-row', {
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', [_c('tit-primary', [_vm._v("공지사항")])], 1), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('router-link', {
    staticClass: "main-notice-list__more-btn",
    attrs: {
      "to": "/notice"
    }
  }, [_c('txt-primary', {
    staticClass: "txt--sm"
  }, [_vm._v("MORE"), _c('span', {
    staticClass: "plus"
  }, [_vm._v("+")])])], 1)], 1)], 1), _c('ul', {
    staticClass: "main-notice-list__table"
  }, _vm._l(_vm.notifications, function (notification, index) {
    return _c('li', {
      key: index
    }, [_c('router-link', {
      attrs: {
        "to": `/notice/${notification._id}`
      }
    }, [_c('div', {
      staticClass: "subject text-truncate"
    }, [_vm._v(" " + _vm._s(notification.subject) + " ")]), _c('div', {
      staticClass: "date"
    }, [_vm._v(" " + _vm._s(_vm.$dayjs(notification.createdAt).format("YYYY-MM-DD")) + " ")])])], 1);
  }), 0)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }